import { render, staticRenderFns } from "./AllRequests.vue?vue&type=template&id=2a523753&scoped=true&"
import script from "./AllRequests.vue?vue&type=script&lang=js&"
export * from "./AllRequests.vue?vue&type=script&lang=js&"
import style0 from "./AllRequests.vue?vue&type=style&index=0&id=2a523753&prod&lang=scss&scoped=true&"
import style1 from "./AllRequests.vue?vue&type=style&index=1&id=2a523753&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a523753",
  null
  
)

export default component.exports